/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateCustomerNoteRequest
 */
export interface CreateCustomerNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerNoteRequest
     */
    text?: string;
}

/**
 * Check if a given object implements the CreateCustomerNoteRequest interface.
 */
export function instanceOfCreateCustomerNoteRequest(value: object): boolean {
    return true;
}

export function CreateCustomerNoteRequestFromJSON(json: any): CreateCustomerNoteRequest {
    return CreateCustomerNoteRequestFromJSONTyped(json, false);
}

export function CreateCustomerNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCustomerNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function CreateCustomerNoteRequestToJSON(value?: CreateCustomerNoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'text': value['text'],
    };
}

